import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { WidgetsTableData } from '../../user-admin.model';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { cloneDeep } from 'lodash';

@Component({
  selector: 'cv-widget-access-cell-renderer',
  templateUrl: './widget-access-cell-renderer.component.html',
  styleUrls: ['./widget-access-cell-renderer.component.scss']
})
export class WidgetAccessCellRendererComponent implements ICellRendererAngularComp {

  public responsiveWidgets: WidgetsTableData[] = [];
  public filteredResponsiveWidgets: WidgetsTableData[] = [];
  public editMode = false;
  public widgetData;
  public parameters: ICellRendererParams;
  public roleHoverMessage: string = "";
  public readHoverMessage: string = "";
  public localizationNames: Map<string, string>;
  public localizationDescriptions: Map<string, string>;
  public localization: Map<string, string>;
  public searchText: string = "";
  public hasWidgets: boolean = false;

  constructor(
    private cvLocalizationFactory: CVLocalizationService,
    private cdr: ChangeDetectorRef
  ) { 
  }

  /**
  * Async aginit for ag-grid cell renderer. loads localization and then calls setValues function
  * */
  async agInit(params: ICellRendererParams): Promise<void> {
    this.parameters = params;

    this.localization = await this.cvLocalizationFactory.GetSection("Users");

    if(params.node.data != null){
      this.setValues(params);
    }
  }

  /**
  * Function to be called after the user types into the search box. it manually filters the different widgets in each row. 
  * uses ag-grid context to get the search value. This is not the initial filtering
  * */
  refresh(searchText): boolean {
    this.searchText = searchText;

    if(searchText == ""){
      this.filteredResponsiveWidgets = this.responsiveWidgets;
    }
    else{
      this.filteredResponsiveWidgets = [];

      this.responsiveWidgets.forEach(widget => {
        if(widget.ModuleName.toLowerCase().includes(searchText.toLowerCase()) || widget.ModuleDescription.toLowerCase().includes(searchText.toLowerCase())){
          this.filteredResponsiveWidgets.push(widget);
        }
      });
    }

    if(this.filteredResponsiveWidgets.length == 0){
      this.hasWidgets = false;
    }
    else{
      this.hasWidgets = true;
    }

    this.cdr.detectChanges();

    return false;
  }

  /**
  * function to set initial values for when the cell renderer is opened. It sets popover messages, set's the localization, and does the initial filtering
  * */
  public setValues(params: ICellRendererParams){
    this.widgetData = params.node.data.TableData;
    let salespackageName = params.node.data.SalesPackageName;

    if(params.context.editMode){
      this.editMode = true;
      this.roleHoverMessage = this.localization.get("Role_Default");
    }
    else{
      this.roleHoverMessage = this.localization.get("Pencil_Icon_Message");
      this.readHoverMessage = this.localization.get("Pencil_Icon_Message");
    }

    this.widgetData.forEach(widget => {

      if(widget.RoleReadAccess){
        widget.ReadAccess = true;
      }

      this.responsiveWidgets.push(widget);
    });

    if(params.context.searchText != ""){
      
      this.responsiveWidgets.forEach(widget => {
        if(salespackageName.toLowerCase().includes(params.context.searchText.toLowerCase()) || 
        widget.ModuleName.toLowerCase().includes(params.context.searchText.toLowerCase()) || 
        widget.ModuleDescription.toLowerCase().includes(params.context.searchText.toLowerCase())){
          this.filteredResponsiveWidgets.push(widget);
        }
      });
    }
    else{
      this.filteredResponsiveWidgets = this.responsiveWidgets;
    }

    if(this.filteredResponsiveWidgets.length == 0){
      this.hasWidgets = false;
    }
    else{
      this.hasWidgets = true;
    }
  }

  
  public ReadAccessChanged(widget){
    const changedWidget = this.parameters.context.changedWidgets.find(w => w.ModuleID === widget.ModuleID && w.IsLegacy === widget.IsLegacy);
    if (changedWidget) {
      changedWidget.ReadAccess = widget.ReadAccess;
      this.parameters.context.enableChanges();
      return;
    }

    this.parameters.context.changedWidgets.push(cloneDeep(widget));
    this.parameters.context.enableChanges();
  }
}
